<template>
  <div>
    <!-- HEARTBEAT SIMULATIONS PRESET-->
    <b-form-group
        description="Choose from different themes for the card images."
    >
      <drop-down-field
          field-name="Simulation Preset Selection:"
          field-key="preset"
          :options-json="optionsJSON"
          :selected-value="preset"
          select-word="Auto-Fills"
          @selected-option="handleOptionsSelect"
      />
    </b-form-group>
    <hr />
    <!-- HEARTBEAT STAGE OF DEMENIA -->
    <b-form-group
        description="Choose from various stages of dementia."
    >
      <drop-down-field
          field-name="Dementia Stage:"
          field-key="stage"
          :options-json="optionsJSON"
          :selected-value="stage"
          select-word="Stage of Dementia"
          @selected-option="handleOptionsSelect"
      />
    </b-form-group>

    <!-- VITALS -->
    <h5>Vitals</h5>
    <div style="
    padding: 15px;
    border-color: #ffc727;
    border-width: 3px;
    border-radius: 15px;
    border-style: solid"
    >
    <b-row>
      <b-col>
        <b-form-group>
          <label-info
              id="heartbeat"
              label-name="Body Temperature"
              label-info=""
              :is-required="true"
          />
          <b-form-input
              type="number"
              required
              v-model="bodyTemp"
              @input="handleValueChange('simulation.bodyTemp', bodyTemp)"
              placeholder="90"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label-info
              id="heartbeat"
              label-name="Heart Rate"
              label-info=""
              :is-required="true"
          />
          <b-form-input
              type="number"
              required
              v-model="heartRate"
              @input="handleValueChange('simulation.heartRate', heartRate)"
              placeholder="90"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <label-info
              id="rate-resp"
              label-name="Respiration Rate"
              label-info=""
              :is-required="true"
          />
          <b-form-input
              type="number"
              required
              v-model="respRate"
              @input="handleValueChange('simulation.respRate', respRate)"
              placeholder="90"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label-info
              id="blood-pressure"
              label-name="Blood Pressure"
              label-info=""
              :is-required="true"
          />
          <b-form-input
              type="number"
              required
              v-model="bp"
              @input="handleValueChange('simulation.bp', bp)"
              placeholder="90"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
        <b-col>
          <b-form-group>
            <label-info
                id="oxygen-sat"
                label-name="Oxygen Saturation"
                label-info=""
                :is-required="true"
            />
            <b-form-input
                type="number"
                required
                v-model="respRate"
                @input="handleValueChange('simulation.respRate', respRate)"
                placeholder="90"
            />
          </b-form-group>
        </b-col>
        <b-col>
          &nbsp;
        </b-col>
      </b-row>
    </div>
    <template v-if="false">
      <b-row>
        <b-col class="text-center">
          <b-img
              v-if="imgURL"
              v-bind="mainProps"
              :src="imgURL"
              rounded
              style="object-fit: scale-down"
              :alt="` Company logo`"
          />
          <image-upload
              v-else
              ref="image-upload"
              text-drag="Upload or Drag Care Plan Cover Photo (.png, .jpg)"
              :img-upload-idx="idx"
              img-upload-type="careplans"
              :storage-path="storagePath"
              :max-image="1"
              :show-edit="false"
              :show-delete="false"
              style="height:90%;width:90%"
              @img-uploaded-url="handleImgUploadedURL"
          />
        </b-col>
      </b-row>
      <b-row style="margin-top: 15px">
        <b-col>
          <b-row>
            <b-col>
              <!-- HEARTBEAT FIRST  NAME  -->
              <b-form-group>
                <label-info
                    id="heartbeat"
                    label-name="First Name"
                    label-info=""
                    :is-required="true"
                />
                <b-form-input
                    type="text"
                    required
                    v-model="firstname"
                    @input="handleValueChange('heartbeat.firstname', firstname)"
                    placeholder="First Name"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <!-- LASTNAME -->
              <b-form-group>
                <label-info
                    id="last"
                    label-name="Last Name"
                    label-info=""
                    :is-required="true"
                />
                <b-form-input
                    type="text"
                    required
                    v-model="lastname"
                    @input="handleValueChange('heartbeat.lastname', lastname)"
                    placeholder="Last  Name"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <!-- LANGUAGE -->
              <b-form-group
                  label="Language"
                  class="custom-label">
                <vue-bootstrap-typeahead
                    id="language"
                    ref="language"
                    v-model="language"
                    no-resize
                    :data="$typeAheadAboutsLanguage"
                    @input="handleValueChange('heartbeat.language', language)"
                    placeholder="Language here..."
                    :serializer="s => `${s.text}`"
                    @hit="$event => (language = $event.value)"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <!-- TIMEZONE -->
              <b-form-group>
                <label-info
                    id="timezone"
                    label-name="Time Zone"
                    label-info=""
                    :is-required="true"
                />
                <vue-bootstrap-typeahead
                    id="timezone"
                    ref="timezone"
                    v-model="timezone"
                    no-resize
                    :data="$typeAheadAboutsTimezone"
                    @input="handleValueChange('heartbeat.timezone', timezone)"
                    placeholder="Timezone here ..."
                    :serializer="s => `${s.text}`"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <!-- SPIRITUAL -->
              <b-form-group>
                <label-info
                    id="spiritual"
                    label-name="Spiritual"
                    label-info=""
                    :is-required="true"
                />
                <vue-bootstrap-typeahead
                    id="spiritual"
                    ref="spiritual"
                    v-model="spiritual"
                    no-resize
                    :data="$typeAheadAboutsSpiritual"
                    @input="handleValueChange('heartbeat.spiritual', spiritual)"
                    placeholder="Spiritual here ..."
                    :serializer="s => `${s.text}`"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <!-- POLITICAL -->
              <b-form-group>
                <label-info
                    id="political"
                    label-name="Political"
                    label-info=""
                    :is-required="true"
                />
                <vue-bootstrap-typeahead
                    id="political"
                    ref="political"
                    v-model="political"
                    no-resize
                    :data="$typeAheadAboutsPolitical"
                    @input="handleValueChange('heartbeat.political', political)"
                    placeholder="Political here ..."
                    :serializer="s => `${s.text}`"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <template v-if="true">
            <!-- GENDER -->
            <!-- INTERVIEWE Relation  -->
            <b-form-group>
              <label-info
                  id="fam-relation-to"
                  label-name="Relation to HeartBeat"
                  label-info=""
                  :is-required="true"
              />
              <vue-bootstrap-typeahead
                  id="famRelationTo"
                  ref="famRelationTo"
                  v-model="famRelationTo"
                  no-resize
                  :data="$typeAheadRelations"
                  @input="handleValueChange('fam.relationTo', famRelationTo)"
                  placeholder="Relationship here ..."
                  :serializer="s => `${s.text}`"
              />
            </b-form-group>

            <template v-if="famRelationTo !== 'self'">
              <b-row>
                <b-col>
                  <!-- FAM FIRST NAME  -->
                  <b-form-group>
                    <label-info
                        id="fam-firstname"
                        label-name="Interviewee First Name"
                        label-info=""
                        :is-required="true"
                    />
                    <b-form-input
                        required
                        v-model="famFirstname"
                        type="text"
                        @input="handleValueChange('fam.firstname', famFirstname)"
                        placeholder="First Name"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <!-- FAM LAST  NAME  -->
                  <b-form-group>
                    <label-info
                        id="fam-lastname"
                        label-name="Last Name"
                        label-info=""
                        :is-required="true"
                    />
                    <b-form-input
                        required
                        v-model="famLastname"
                        type="text"
                        @input="handleValueChange('fam.lastname', famLastname)"
                        placeholder="Last Name"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-row>
              <b-col>
                <!-- EMAIL -->
                <b-form-group>
                  <label-info
                      id="email"
                      label-name="Email Address"
                      label-info=""
                      :is-required="true"
                  />
                  <b-form-input
                      type="text"
                      required
                      v-model="famEmail"
                      @input="handleValueChange('fam.email', famEmail)"
                      placeholder="Email"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <!-- PHONE -->
                <b-form-group>
                  <label-info
                      id="phone"
                      label-name="Phone"
                      label-info=""
                      :is-required="true"
                  />
                  <the-mask
                      id="phone"
                      :mask="[' (###) ###-####', '##.###.###/####-##']"
                      class="custom-input"
                      style="width:100%"
                      type="tel"
                      v-model="famPhone"
                      @input="handleValueChange('fam.phone', famPhone)"
                      placeholder="(310) 621-4068"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
      <!--- DESCRIPTION  -->
      <b-form-group v-if="false">
        <label-info
            id="care-plan-description"
            label-name="Description"
            label-info=""
            :is-required="true"
        />
        <transition name="fadeHeight" mode="out-in">
          <Editor
              id="textarea-default"
              v-show="true"
              @input="input"
              :clear="clear"
              :content="description"
              @resetClear="resetClear"
          />
        </transition>
      </b-form-group>
      <pre v-if="!production" class="small">{{ context }}</pre>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropDownField from "@/components/common/dropDownField";
import LabelInfo from "@/components/common/labelInfo";
import Editor from "@/components/common/editor";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import TheMask from "vue-the-mask/src/component";
import optionsJSON from "./assets/json/optionsJSON.json";
export default {
  name: "AddEditCarePlan_GeneralInfo",
  mixins: [UploadImage],
  components: {
    DropDownField,
    LabelInfo,
    Editor,
    ImageUpload,
    TheMask,
    VueBootstrapTypeahead
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    storagePath:{
      type: String,
      default: 'careplans_care_plan_img'
    }
  },
  beforeMount() {},
  mounted() {
    this.setTypeAheads();
  },
  computed: {
    ...mapGetters({}),
    imgURL(){
      return this.form && this.form.imgURL ? this.form.imgURL : null;
    }
  },
  methods: {
    handleImgUploadedURL(idx, url) {
      this.handleValueChange('imgURL', url);
    },
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    },
    input(val) {
      this.$emit('value-change', {key:'description', value:val.content});
    },
    resetClear() {
      this.clear = false;
    },
    onContext(ctx) {
      this.context = ctx;
     // this.careplan_date_at = ctx.activeFormatted;
     //
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleCalendarDateSelected(date){
      this.$emit('value-change', {key:'careplan_date_at', value: date});
    },
    handleCalendarFocusClick(isFocused){
      this.calendar = isFocused;
    },
    setTypeAheads() {
      setTimeout(() => {
        //LANGUAGE
        if (
            this.language &&
            this.$refs.language
        ) {
          let languages = this.$typeAheadAboutsLanguage.filter(item => {
            return this.language == item.value;
          });

          this.$refs.language.$data.inputValue =
              languages.length > 0
                  ? languages[0].text
                  : this.language;
        }

        //TIMEZONE
        if (
            this.timezone &&
            this.$refs.timezone
        ) {
          let languages = this.$typeAheadAboutsLanguage.filter(item => {
            return this.timezone == item.value;
          });

          this.$refs.timezone.$data.inputValue =
              languages.length > 0
                  ? languages[0].text
                  : this.timezone;
        }

        //SPIRITUAL
        if (
            this.spiritual &&
            this.$refs.spiritual
        )
          this.$refs.spiritual.$data.inputValue = this.spiritual;

        //POLITICAL
        if (
            this.political &&
            this.$refs.political
        )
          this.$refs.political.$data.inputValue = this.political;

        //POLITICAL
        if (
            this.famRelationTo &&
            this.$refs.famRelationTo
        )
          this.$refs.famRelationTo.$data.inputValue = this.famRelationTo;

        }, 100);
    },
    handleOptionsSelect({key, option}){
      debugger;
      this[key] = option.value ? option.value : null;

      this.handleValueChange(`simulation.${key}`, this[key]);
    }
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
     const minDate = new Date(today)

    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth() + 2)
    maxDate.setDate(15)
    return {
      optionsJSON,
      idx:0,
      production: true,
      verticalSpinDur: false,
      clear: false,
      description: null,
      calendar: false,
      context: null,
      calendarMin: minDate,
      calendarMax: maxDate,
      preset: this.form && this.form.simulation &&  this.form.simulation.preset ?
          this.form.simulation.preset : null,
      stage: this.form && this.form.simulation &&  this.form.simulation.stage ?
          this.form.simulation.stage : null,
      bodyTemp: this.form && this.form.simulation &&  this.form.simulation.bodyTemp ?
          this.form.simulation.bodyTemp : null,
      heartRate: this.form && this.form.simulation &&  this.form.simulation.heartRate ?
          this.form.simulation.heartRate : null,
      respRate: this.form && this.form.simulation &&  this.form.simulation.respRate ?
          this.form.simulation.respRate : null,
      bp: this.form && this.form.simulation &&  this.form.simulation.bp ?
          this.form.simulation.bp : null,
      oxygen: this.form && this.form.oxygen &&  this.form.simulation.oxygen ?
          this.form.simulation.oxygen : null,
      firstname: this.form && this.form.heartbeat &&  this.form.heartbeat.firstname ?
          this.form.heartbeat.firstname : null,
      lastname: this.form && this.form.heartbeat && this.form.heartbeat.lastname ?
          this.form.heartbeat.lastname : null,
      language:this.form && this.form.heartbeat && this.form.heartbeat.language ? this.form.heartbeat.language : null,
      timezone: this.form && this.form.heartbeat && this.form.heartbeat.timezone ?
          this.form.heartbeat.timezone : null,
      spiritual: this.form  && this.form.heartbeat && this.form.heartbeat.spiritual ?
          this.form.heartbeat.spiritual : null,
      political: this.form && this.form.heartbeat &&  this.form.heartbeat.political ?
          this.form.heartbeat.political : null,
      famFirstname: this.form && this.form.fam &&  this.form.fam.firstname ?
          this.form.fam.firstname : null,
      famLastname: this.form && this.form.fam && this.form.fam.lastname ?
          this.form.fam.lastname : null,
      famRelationTo: this.form && this.form.fam && this.form.fam.relationTo ?
          this.form.fam.relationTo : null,
      famLanguage: this.form && this.form.fam && this.form.fam.language ?
          this.form.fam.language : null,
      famTimezone: this.form && this.form.fam && this.form.fam.timezone ?
          this.form.fam.timezone : null,
      famSpiritual: this.form  && this.form.fam && this.form.fam.spiritual ?
          this.form.fam.spiritual : null,
      famPolitical: this.form && this.form.fam &&  this.form.fam.political ?
          this.form.fam.political : null,
      famEmail: this.form && this.form.fam && this.form.fam.email ?
          this.form.fam.email : null,
      famPhone: this.form && this.form.fam && this.form.fam.phone ?
          this.form.fam.phone : null,
      mainProps: {
        blank: false,
        blankColor: '#777',
        width: 200,
        height: 200,
        class: 'm1'
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.care-plan-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#care-plan_calender .btn-outline-info:hover,
#care-plan_calender .btn-outline-info:active,
#care-plan_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

